export class ajaxSpinner {
  constructor($dropzone) {
    this.dropzone = $dropzone;

    const $spinnerItem = '<div class="meithrin-spinner-wrap"><span class="meithrin-spinner"><i class="icon-meithrin-m"></i></span></div>';

    this.dropzone.append($spinnerItem);
    this.spinnerItem = $spinnerItem;
  }

  remove() {
    this.dropzone.find('.meithrin-spinner-wrap').remove();
  }
}


// WEBPACK FOOTER //
// ./scripts/util/ajaxSpinner.js